import { TableMemoryPagedService } from "./table.memorypaged.service";
import { TableService } from "./table.service";
import { TableUnlimitedService } from "./table.unlimited.service";

export const TableServices = [
    TableService,
    TableMemoryPagedService,
    TableUnlimitedService
];